<template>
    <div>
        <div class="row">
            <h3 class="mt-3 mb-3 w-100">Firmware Management</h3>

            <div class="w-100">
                <form class="needs-validation" novalidate v-on:submit.prevent="update()">
                    <div class="table-wrapper-scroll-y">
                        <div class="table">
                            <table class="table table-striped table-bordered dev-dashboard-table">
                                <thead class="thead-dark">
                                <tr>
                                    <th>Type</th>
                                    <th>Category</th>
                                    <th>Generation</th>
                                    <th>Current Version</th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-for="(categories, gateway) in firmwares">
                                    <template v-for="(generations, category) in categories">
                                        <template v-for="(version, generation) in generations">
                                            <tr>
                                                <td>{{gateway === '1'?'Gateway':'Device'}}</td>
                                                <td>{{category.replace(/(\W|\_)+/g, ' ')}}</td>
                                                <td v-if="generation === 'n/a'">{{generation}}</td>
                                                <td v-else>{{gateway === '1'?'GW':''}} GEN {{generation}}</td>
                                                <td><input required type="text" v-bind:name="`version[${category}][${gateway}][${generation}]`"
                                                           v-model="firmwares[gateway][category][generation]"
                                                           maxlength="16" placeholder="Current Version" class="form-control"></td>
                                            </tr>
                                        </template>
                                    </template>
                                </template>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="btn-toolbar justify-content-between">
                        <div class="btn-group mr-2" role="group">
                            <button class="btn btn-secondary mb-3" type="button" v-on:click="restore()">Restore</button>
                        </div>
                        <div class="btn-group" role="group" aria-label="Second group">
                            <button class="btn btn-primary mb-3" type="submit">Update</button>
                        </div>
                    </div>

                    <transition name="fade">
                        <div class="alert alert-success my-4" role="alert" v-if="response">
                            Settings updated!
                        </div>
                    </transition>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
  import Vue from 'vue';
  import DeviceModel from '@/app-model/deviceModel.js';

  export default {
    data () {
      return {
        firmwareOptionKey: undefined,
        firmwares_org : '',
        firmwares: {},
        generationConfig: {},
        firmwareCategory: {},
        response: false
      }
    },
    mounted () {
      this.load();
    },
    computed: {
      deviceModelTools: function () {
        return new DeviceModel;
      },
    },
    methods: {
      getVersion(gateway, generation, category) {
        return this.firmwares?.[gateway]?.[generation]?.[category];
      },
      load () {
        this.deviceModelTools.all({store: this.$store}).then(({response, result}) => {
          let {firmware_key, generations, firmware_category} = result;
          if (firmware_key) {
            this.firmwareOptionKey = firmware_key;
            Vue.set(this, 'generationConfig', Object.assign({}, generations));
            Vue.set(this, 'firmwareCategory', Object.assign({}, firmware_category));
          }
          return {response, result};
        }).then(({response, result}) => {
          if (this.firmwareOptionKey) {
            this.deviceModelTools.getDefaultFirmware(
              {store: this.$store},
              this.firmwareOptionKey,
              this.generationConfig,
              this.firmwareCategory
            ).then(({response, result}) => {
              let {firmwares} = result;
              if (firmwares) {
                Vue.set(this, 'firmwares_org', JSON.stringify(firmwares));
                Vue.set(this, 'firmwares', JSON.parse(this.firmwares_org));
              }
            });
          }
        });
      },
      restore () {
        this.firmwares = JSON.parse(this.firmwares_org);
      },
      update () {
        let top = this;
        this.deviceModelTools.updateDefaultFirmware(
          {store: this.$store},
          this.firmwareOptionKey,
          this.firmwares,
          this.generationConfig,
          this.firmwareCategory
        ).then(({response, result}) => {
          let {firmwares} = result;
          if (firmwares) {
            this.response = true;
            setTimeout(function () {
              top.response = false;
            }, 1000);
          }
          return {response, result: {firmwares}};
        });
      }
    }
  }
</script>